<template>
    <div class="linker-manage" v-loading="loading">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="地区">
                    <el-select v-model.trim="formInline.region" clearable @change="search" placeholder="选择地区" style="width: 160px;">
                        <el-option :label="'全部'" :value="''"></el-option>
                        <el-option
                            v-for="item in regionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="客户名称">
                    <el-select clearable filterable v-model.trim="formInline.company_id" placeholder="选择客户" @change="search" style="width: 180px;"
                        :filter-method="customerFilterMethod">
                        <el-option
                            v-for="item in displayedCustomers"
                            :key="item.id"
                            :label="item.company"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="LinkerId">
                    <el-input 
                        v-model.trim="formInline.link_id" 
                        maxlength="60" 
                        clearable 
                        placeholder="输入LinkerId" 
                        @change="search" 
                        style="width: 180px;">
                        <template #prefix>
                            <el-icon><Link /></el-icon>
                        </template>
                    </el-input>
                </el-form-item>

                <el-form-item label="Payer" v-if="curRole!='sales'">
                    <el-select clearable filterable v-model.trim="formInline.payer_id" placeholder="选择Payer" @change="search" style="width: 180px;">
                        <el-option
                            v-for="item in payersList"
                            :key="item.payer_id"
                            :label="item.name+'('+item.payer_id+')'"
                            :value="item.payer_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="伙伴" v-if="curRole!='sales'">
                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="选择伙伴" @change="search" style="width: 160px;">
                        <el-option
                            v-for="item in agentsList"
                            :key="item.agent_id"
                            :label="item.company"
                            :value="item.agent_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="销售" v-if="curRole!='sales'">
                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="选择销售" @change="search" style="width: 140px;">
                        <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select clearable v-model.trim="formInline.status" placeholder="全部状态" @change="search" style="width: 120px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="未创建" value="0"></el-option>
                        <el-option label="已删除" value="-1" v-if="curRole === 'admin'"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="formInline.create_range"
                        type="daterange"
                        value-format="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :shortcuts="createRangeShortcuts"
                        unlink-panels
                        clearable
                        @change="search"
                        style="width: 240px;">
                    </el-date-picker>
                </el-form-item>
                
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search" v-show="isShowBtn('linkerManage','Link管理','Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button @click="add" type="primary" icon="Plus" v-show="isShowBtn('linkerManage','Link管理','Create')">新增Link</el-button></el-form-item>
            </el-form>
        </div>
        <el-tabs v-model="activeTab" class="linker-tabs">
            <el-tab-pane label="Link列表" name="list"></el-tab-pane>
            <el-tab-pane label="BT层级" name="bt"></el-tab-pane>
        </el-tabs>
        <div v-show="activeTab === 'list'">
        <el-table 
            :row-class-name="tableRowClassName" 
            stripe 
            :data="tableData" 
            ref="tableref" 
            v-loading="loadingPage" 
            empty-text="暂无数据"
            style="width: 100%;"
            :height="'calc('+(tableHeight)+'px)'"
            >>
                    
            <el-table-column type="index" width="55" align="center" label="序号" fixed="left">
                <template #default="scope">
                    <span>{{ getIndex(scope.$index) }}</span>
                </template>
            </el-table-column>
            
            <el-table-column min-width="120" prop="company" label="客户名称" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{ scope.row.company }}</span>
                </template>
            </el-table-column>
            
            <el-table-column width="150" prop="link_id" label="LinkerId">
                <template #default="scope">
                    {{ scope.row.link_id }}
                </template>
            </el-table-column>
            
            <el-table-column width="150" prop="payer_id" label="Payer">
                <template #default="scope">
                    {{ scope.row.payer_id }}
                </template>
            </el-table-column>

            <el-table-column width="130" prop="bt_kind" label="BT类型" align="center">
                <template #default="scope">
                    <el-tag v-if="scope.row.bt_kind === 'pma'" type="warning" size="small">PMA</el-tag>
                    <el-tag v-else-if="scope.row.bt_kind === 'cma'" type="success" size="small">CMA</el-tag>
                    <span v-else>-</span>
                    <span v-if="scope.row.cma_name" style="margin-left:4px;font-size:12px;color:#909399;">{{ scope.row.cma_name }}</span>
                </template>
            </el-table-column>
            
            <el-table-column min-width="120" prop="agent_id" label="伙伴" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{ agentMap.get(scope.row.agent_id) || scope.row.agent_id }}</span>
                </template>
            </el-table-column>

            <el-table-column width="80" prop="sales" label="销售">
                <template #default="scope">
                    <span>{{ scope.row.sales }}</span>
                </template>
            </el-table-column>
            
            <el-table-column min-width="160" prop="email" label="邮箱" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{ scope.row.email }}</span>
                </template>
            </el-table-column>
            
            <el-table-column width="70" prop="region" label="地区" align="center">
                <template #default="scope">
                    <el-tag size="small" :type="scope.row.region === 'cn' ? 'success' : 'warning'">
                        {{ scope.row.region === 'cn' ? '中国' : 'Global' }}
                    </el-tag>
                </template>
            </el-table-column>
            
            <el-table-column width="70" align="center" prop="budget" label="预算">
                <template #default="scope">
                    {{ scope.row.budget || 0 }}
                </template>
            </el-table-column>
            
            <el-table-column width="70" prop="status" label="状态" align="center">
                <template #default="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 0 ? 'warning' : 'danger'" size="small">
                        {{ scope.row.status === 1 ? '正常' : scope.row.status === 0 ? '未创建' : '已删除' }}
                    </el-tag>
                </template>
            </el-table-column>
            
            <el-table-column width="150" prop="create_datetime" label="创建时间" align="center">
                <template #default="scope">
                    {{ scope.row.create_datetime || '-' }}
                </template>
            </el-table-column>
            
            <el-table-column label="操作" width="100" align="center" fixed="right">
                <template #default="scope">
                    <el-button size="small" link type="primary" @click="config(scope.row)" v-show="isShowBtn('linkerManage','Link管理','Config')" icon="Setting"></el-button>
                    <el-button size="small" link type="primary" @click="edit(scope.row)" v-show="isShowBtn('linkerManage','Link管理','Update') && scope.row.status !== -1" icon="Edit"></el-button>
                    <el-button size="small" link type="danger" @click="remove(scope.row.id)" v-show="isShowBtn('linkerManage','Link管理','Delete') && scope.row.status !== -1" icon="Delete"></el-button>
                    <el-button size="small" link type="success" @click="restore(scope.row.id)" v-show="scope.row.status === -1 && curRole === 'admin'" icon="RefreshRight"></el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <div v-if="activeTab === 'bt'" v-loading="btLoading">
            <div class="bt-toolbar">
                <span class="bt-summary">
                    佳杰PMA <b>{{ btSummary.payers }}</b> 个 · 二代PMA <b>{{ btSummary.pmas }}</b> 个 · CMA <b>{{ btSummary.cmas }}</b> 个 · Link <b>{{ btSummary.links }}</b> 个
                </span>
                <el-button size="small" @click="expandBtTree(true)">展开全部</el-button>
                <el-button size="small" @click="expandBtTree(false)">收起全部</el-button>
            </div>
            <el-table
                ref="btTable"
                :data="btTree"
                row-key="row_key"
                :tree-props="{ children: 'children' }"
                :expand-row-keys="btExpandKeys"
                :row-class-name="btRowClassName"
                empty-text="暂无BT数据"
                style="width: 100%;"
                :height="'calc('+(tableHeight - 40)+'px)'">
                <el-table-column label="层级 / 账号" min-width="300">
                    <template #default="scope">
                        <el-tag v-if="btLevelMeta[scope.row.node_type]" :type="btLevelMeta[scope.row.node_type].type" size="small" effect="plain" class="bt-level-tag">
                            {{ btLevelMeta[scope.row.node_type].label }}
                        </el-tag>
                        <span class="bt-account">{{ scope.row.account_id }}</span>
                        <el-tag v-if="scope.row.node_type === 'link' && scope.row.is_root" size="small" type="info" class="bt-root-tag">树根</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="名称" min-width="220" show-overflow-tooltip>
                    <template #default="scope">
                        <span :class="{ 'bt-group-title': scope.row.node_type !== 'link' }">{{ scope.row.title || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Link数" width="80" align="center">
                    <template #default="scope">
                        <span v-if="scope.row.node_type !== 'link'">{{ scope.row.link_count }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="伙伴" min-width="160" show-overflow-tooltip>
                    <template #default="scope">{{ scope.row.agent_name || '' }}</template>
                </el-table-column>
                <el-table-column label="销售" width="90">
                    <template #default="scope">{{ scope.row.sales || '' }}</template>
                </el-table-column>
                <el-table-column label="状态" width="80" align="center">
                    <template #default="scope">
                        <template v-if="scope.row.node_type === 'link'">
                            <el-tag v-if="!scope.row.registered" type="info" size="small">未登记</el-tag>
                            <el-tag v-else :type="scope.row.status === 1 ? 'success' : scope.row.status === 0 ? 'warning' : 'danger'" size="small">
                                {{ scope.row.status === 1 ? '正常' : scope.row.status === 0 ? '未创建' : '已删除' }}
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="150" align="center">
                    <template #default="scope">{{ scope.row.node_type === 'link' ? (scope.row.create_datetime || '-') : '' }}</template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center" fixed="right">
                    <template #default="scope">
                        <el-button v-if="scope.row.node_type === 'link' && scope.row.registered" size="small" link type="primary" @click="viewInList(scope.row.account_id)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination 
            v-show="activeTab === 'list'"
            :key="pageparm.total" 
            v-bind:child-msg="pageparm" 
            @callFather="callFather"
            :pageSizes="[10,20,30,40,50,100]">
        </Pagination>
        <el-dialog 
            v-model="deleteDialogVisible" 
            :close-on-click-modal="false" 
            title="删除确认"
            width="520px">
            
            <div>
                <p>确定要删除这个Link吗？</p>
                <el-radio-group v-model="deleteType">
                    <el-radio label="soft">软删除（推荐）</el-radio>
                    <el-radio label="hard" v-if="curRole === 'admin'">硬删除（谨慎）</el-radio>
                </el-radio-group>
                <el-input 
                    v-model="deleteReason" 
                    type="textarea" 
                    :rows="3" 
                    placeholder="请输入删除原因（可选）"
                    style="margin-top: 15px;">
                </el-input>
            </div>
            
            <template #footer>
                <el-button @click="cancelDelete">取消</el-button>
                <el-button type="danger" @click="confirmDelete" :loading="deleteLoading">
                    {{ deleteType === 'hard' ? '永久删除' : '删除' }}
                </el-button>
            </template>
        </el-dialog>

        <!-- Edit Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel"
            :title="loadingTitle"
            width="650px">

            <el-form 
                :model="formData" 
                :rules="rules" 
                ref="rulesForm" 
                label-position="right" 
                label-width="120px">
                
                <div v-if="!isConfig">
                    <el-form-item label="地区" prop="region">
                        <el-radio-group v-model="formData.region">
                            <el-radio v-for="item in regionList" :key="item.value" :label="item.value">
                                {{ item.label }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item label="客户名称" prop="company">
                        <el-select clearable filterable v-model.trim="formData.company_id" placeholder="请选择客户（可不选）">
                            <el-option
                                v-for="item in customersList"
                                :key="item.id"
                                :label="item.company"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="LinkerId" prop="link_id">
                        <el-input v-model="formData.link_id" placeholder="请输入LinkerId"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="Linker名称" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入Linker名称"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="Payer" prop="payer_id">
                        <el-select v-model="formData.payer_id" filterable placeholder="请选择Payer">
                            <el-option
                                v-for="(item,index) in payersList"
                                :key="index"
                                :label="item.name+'('+item.payer_id+')'"
                                :value="item.payer_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="伙伴" prop="agent_id">
                        <el-select v-model="formData.agent_id" filterable placeholder="请选择伙伴">
                            <el-option
                                v-for="(item,index) in agentsList" 
                                :key="index"
                                :label="item.company"
                                :value="item.agent_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="销售" prop="sales">
                        <el-select v-model="formData.sales" filterable placeholder="请选择销售">
                            <el-option
                                v-for="(item,index) in salesList"
                                :key="index"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="formData.email" placeholder="请输入邮箱地址"></el-input>
                    </el-form-item>
                </div>
                
                <div v-if="isEdit && isConfig">
                    <el-form-item label="预算" prop="budget">
                        <el-input type="number" v-model="formData.budget" placeholder="请输入预算">
                            <template #suffix>USD</template>
                        </el-input>
                    </el-form-item>
                    
                    <el-form-item label="告警阈值" prop="budget2">
                        <el-input type="number" v-model="formData.budget2" placeholder="请输入告警阈值">
                            <template #suffix>USD</template>
                        </el-input>
                    </el-form-item>
                    
                    <el-form-item label="告警邮箱" prop="email2">
                        <el-input v-model="formData.email2" placeholder="请输入告警邮箱"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="动作" prop="policy_id">
                        <el-select v-model="formData.policy_id" filterable placeholder="请选择动作">
                            <el-option
                                v-for="(item,index) in allPolicyData"
                                :key="index"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>

            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="isEdit ? editSubmit(formData.id) : submitData()">
                    确定
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination";
    import {getLinkerList,getBtLinkTree,getBillWarning,newLinker,deleterLinker,editLinker,getCustomerList,getPayerList,getAgentList,getSalesList,listPolicy,listPolicyAws} from '@/api/api'
    import {getTableHeight, isShowBtn} from "@/utils/util";
    import { WarningFilled, Grid, OfficeBuilding, CreditCard, User, Setting, Check, Close, Warning, QuestionFilled, Bell, Edit, Delete, RefreshRight, Hide, Link, Search, Document, Plus, Message, LocationFilled, Location } from '@element-plus/icons-vue';
    export default {
        components:{
            Pagination,
            WarningFilled,
            Grid,
            OfficeBuilding,
            CreditCard,
            User,
            Setting,
            Check,
            Close,
            Warning,
            QuestionFilled,
            Bell,
            Edit,
            Delete,
            RefreshRight,
            Hide,
            Link,
            Search,
            Document,
            Plus,
            Message,
            LocationFilled,
            Location
        },
        name:'linkerManage',
        data() {
            const checkEmail = (rule, value, callback) => {
                if (value) {
                    var reg = /^[0-9a-zA-Z_+.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+)$/
                    if (reg.test(value) === false) {
                        callback(new Error('邮箱格式错误'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            };
            const checkNumber = (rule,value,callback) => {
                if(value){
                    var reg = /^(\d{12})$/
                    if (reg.test(value) === false) {
                        callback(new Error('请输入12位数字'))
                    } else {
                        callback()
                    }
                }else{
                    callback()
                }
            };
            return {
                loadingPage:false,
                tableHeight:500,
                // 删除相关
                deleteDialogVisible: false,
                deleteType: 'soft', // 'soft' 或 'hard'
                deleteReason: '',
                deleteLoading: false,
                currentDeleteId: null,
                formInline:{
                    company_id:'',
                    link_id:'',
                    region:'',
                    payer_id:'',
                    agent_id:'',
                    status:'',
                    sales:'',
                    create_range: [],
                    page: 1,
                    limit:14,
                },
                activeTab: 'list',
                btTree: [],
                btSummary: { payers: 0, pmas: 0, cmas: 0, links: 0 },
                btExpandKeys: [],
                btLoading: false,
                btLevelMeta: {
                    payer: { label: '佳杰PMA', type: 'danger' },
                    pma: { label: '二代PMA', type: 'warning' },
                    cma: { label: 'CMA', type: 'success' },
                    pma_own: { label: 'PMA自有', type: 'info' },
                    unmapped: { label: '未归属', type: 'info' },
                    link: { label: 'Link', type: '' },
                },
                createRangeShortcuts: [
                    { text: '最近7天', value: () => { const e = new Date(); const s = new Date(); s.setDate(e.getDate() - 6); return [s, e]; } },
                    { text: '最近30天', value: () => { const e = new Date(); const s = new Date(); s.setDate(e.getDate() - 29); return [s, e]; } },
                    { text: '本月', value: () => { const e = new Date(); return [new Date(e.getFullYear(), e.getMonth(), 1), e]; } },
                    { text: '上月', value: () => { const n = new Date(); return [new Date(n.getFullYear(), n.getMonth() - 1, 1), new Date(n.getFullYear(), n.getMonth(), 0)]; } },
                ],
                value2: true,
                value3: '',
                value4: 0.0,
                loadingTitle:'新增用户',
                dialogVisible:false,
                formData:{
                    company_id:'',
                    link_id:'',
                    name:'',
                    payer_id:'',
                    agent_id:'',
                    sales:'',
                    region:'',
                    email:'',
                    budget:0,
                    budget2:0,
                    email2:'',
                    policy_id:''
                },
                isEdit:false,
                isConfig:false,
                pageparm: {
                    page: 1,
                    limit:14,
                    total: 0  // 初始值为0，将由getData()更新
                },
                tableData:[],
                payersList:[],
                agentsList:[],
                customersList:[],
                displayedCustomers:[],
                salesList:[],
                regionList:[
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                rules: {
                    region: [
                        { required: true, message: '请选择地区', trigger: 'change' }
                    ],
                    link_id:[
                        { required: true, message: '请输入用户Id', trigger: 'blur' },
                        { required: true, trigger: 'blur', validator: checkNumber }
                    ],
                    name:[
                        { required: false, message: '请输入LinkerName', trigger: 'blur' }
                    ],
                    payer_id:[
                        { required: true, message: '请绑定Payer', trigger: 'blur' }
                    ],
                    agent_id:[
                        { required: true, message: '请绑定伙伴', trigger: 'blur' }
                    ],
                    sales:[
                        { required: true, message: '请绑定销售', trigger: 'blur' }
                    ],
                    email: [
                        { required: false, trigger: 'blur', validator: checkEmail }
                    ]
                },
                curRole:localStorage.getItem('curRole'),
                agentMap:new Map(), // 初始化为空Map而不是null
                allPolicyData:[],
                loading:false,
            }
        },
        
        created() {
            // 初始化加载
            this.loading = true;
            
            // 如果是销售角色，设置销售名称
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account')
            }
            
            // 处理URL参数
            if(this.$route.query.id){
                this.formInline.status = '0';
            }
            
            // 先加载筛选项（含agentMap），再加载表格数据
            const filterPromises = [this.getCustomers()];
            if(this.curRole === 'admin') {
                filterPromises.push(this.getAgents(), this.getSales(), this.getPayers());
            } else if(this.curRole === 'sales') {
                filterPromises.push(this.getAgents(), this.getPayers());
            } else if(this.curRole === 'agent') {
                filterPromises.push(this.getPayers());
            }
            
            Promise.all(filterPromises).then(() => {
                // 构建agentMap（表格渲染前）
                if (this.agentsList.length > 0) {
                    this.agentMap = new Map();
                    this.agentsList.forEach(el => {
                        this.agentMap.set(el.agent_id, el.company);
                    });
                }
                // 筛选项就绪后再加载表格
                return this.getData();
            }).catch(error => {
                console.error('初始化数据加载失败:', error);
                this.$message.error('数据加载失败，请刷新页面重试');
            }).finally(() => {
                this.loading = false;
            });
        },

        methods:{
            // 筛选条件 -> 接口参数（创建时间段拆成 create_start/create_end）
            buildQueryParams() {
                const data = JSON.parse(JSON.stringify(this.formInline));
                const range = data.create_range || [];
                delete data.create_range;
                if (range.length === 2) {
                    data.create_start = range[0];
                    data.create_end = range[1];
                }
                if (data.status === '') {
                    delete data.status;
                }
                return data;
            },
            //获取列表
            async getData() {
                if (this.activeTab === 'bt') {
                    return this.getBtTree();
                }
                this.loadingPage = true;
                try {
                    var data = this.buildQueryParams();
                    
                    const res = await getLinkerList(data);
                    this.loadingPage = false;
                    
                    if(res.code == 2000) {
                        if (res.msg && res.msg.includes('not authenticated')) {
                            this.$message.error('认证失败,请重新登录');
                            this.$router.push('/login');
                            return;
                        }
                        
                        this.tableData = res.data
                        this.pageparm.page = res.page;
                        this.pageparm.limit = res.limit;
                        this.pageparm.total = res.total;
                    } else {
                        this.$message.error('获取数据失败：' + res.msg);
                    }
                } catch (error) {
                    this.loadingPage = false;
                    console.error('API请求错误:', error);
                    this.$message.error('网络请求失败，请稍后重试');
                }
            },

            // 新增保存linker
            submitData(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        newLinker(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData()
                                this.getAllLinkers()
                                this.getWarningList()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));;
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            editSubmit(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        this.formData.status = 1;
                        editLinker(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                                this.getAllLinkers()
                                this.getWarningList()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));;
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            add(){
                this.cancel();
                this.dialogVisible=true;
                this.isEdit=false;
                this.isConfig = false;
                this.loadingTitle="新增Linker"
            },
            // 编辑linker账号
            edit(obj){
                this.isConfig = false;
                this.formData=JSON.parse(JSON.stringify(obj));
                
                this.dialogVisible=true;
                this.isEdit=true;
                this.loadingTitle="编辑Linker"
            },
            async addWarning(obj){
                this.loading = true;
                this.formData=JSON.parse(JSON.stringify(obj));
                await this.getAllPolicyList(this.formData.payer_id);
                this.loading =false;
                this.isEdit = true;
                this.isConfig = true;
                this.dialogVisible=true;
                this.loadingTitle="配置预算";
            },
            // 删除linker账号
            remove(id){
                this.currentDeleteId = id;
                this.deleteType = 'soft'; // 默认软删除
                this.deleteReason = '';
                this.deleteDialogVisible = true;
            },
            
            // 取消删除
            cancelDelete(){
                this.deleteDialogVisible = false;
                this.currentDeleteId = null;
                this.deleteReason = '';
                this.deleteType = 'soft';
            },
            
            // 确认删除
            confirmDelete(){
                if (!this.currentDeleteId) {
                    this.$message.error('删除ID无效');
                    return;
                }
                
                this.deleteLoading = true;
                
                // 准备删除参数
                const deleteParams = {
                    id: this.currentDeleteId
                };
                
                // 如果是硬删除或有删除原因，添加到请求体
                if (this.deleteType === 'hard' || this.deleteReason) {
                    deleteParams.hard_delete = this.deleteType === 'hard';
                    if (this.deleteReason) {
                        deleteParams.reason = this.deleteReason;
                    }
                }
                
                deleterLinker(deleteParams).then(res=>{
                    this.deleteLoading = false;
                    if(res.code==2000){
                        this.$message.success(res.msg);
                        this.deleteDialogVisible = false;
                        this.getData();
                        this.getAllLinkers();
                        this.getWarningList();
                        this.cancelDelete(); // 重置删除状态
                    }else{
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(err => {
                    this.deleteLoading = false;
                    this.$message.error('删除请求失败，请稍后重试');
                    console.error('删除失败:', err);
                });
            },
            
            // 恢复Linker
            restore(id){
                this.$confirm('确定恢复这个Link吗？恢复后将重新显示在正常列表中。','恢复确认',{
                    confirmButtonText:'确定恢复',
                    cancelButtonText:'取消',
                    type: 'success'
                }).then(()=>{
                    // 调用恢复API，这里需要发送POST请求到restore端点
                    this.$axios.post(`/linker/${id}/restore/`).then(res=>{
                        if(res.data.code==2000){
                            this.$message.success('恢复成功！');
                            this.getData();
                            this.getAllLinkers();
                            this.getWarningList();
                        }else{
                            this.$message.error(res.data.msg || '恢复失败');
                        }
                    }).catch(err => {
                        this.$message.error('恢复请求失败，请稍后重试');
                        console.error('恢复失败:', err);
                    });
                }).catch(err=>{});
            },
            
            cancel(){
                this.formData={
                    company:'',
                    link_id:'',
                    name:'',
                    payer_id:'',
                    agent_id:'',
                    sales:'',
                    region:'',
                    email:'',
                    budget:0,
                    budget2:0,
                    email2:'',
                    policy_id:''
                };
                this.isEdit=false;
                this.dialogVisible=false;
            },
            reset() {
                this.formInline = {
                    company_id:'',
                    region:'',
                    link_id:'',
                    payer_id:'',
                    agent_id:'',
                    sales: this.curRole === 'sales' ? localStorage.getItem('account') : '',
                    status:'',
                    create_range: [],
                    page:1,
                    limit: this.formInline.limit || 14
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                // 筛选条件变化回到第一页，否则停在后面的页可能查成空
                this.formInline.page = 1
                this.getData()
            },
            async getBtTree() {
                this.btLoading = true;
                try {
                    const params = this.buildQueryParams();
                    delete params.page;
                    delete params.limit;
                    const res = await getBtLinkTree(params);
                    if (res.code == 2000 && res.data) {
                        this.btTree = res.data.tree || [];
                        this.btSummary = res.data.summary || { payers: 0, pmas: 0, cmas: 0, links: 0 };
                        // 筛到少量 payer 时直接全展开，否则只展开到二代PMA层
                        this.btExpandKeys = this.btTree.length <= 3
                            ? this.collectBtKeys(this.btTree, true)
                            : this.btTree.map(n => n.row_key);
                    } else {
                        this.$message.error('获取BT层级失败：' + (res.msg || ''));
                    }
                } catch (error) {
                    console.error('获取BT层级失败:', error);
                    this.$message.error('获取BT层级失败，请稍后重试');
                } finally {
                    this.btLoading = false;
                }
            },
            collectBtKeys(nodes, deep) {
                const keys = [];
                const walk = list => list.forEach(n => {
                    if (n.children && n.children.length) {
                        keys.push(n.row_key);
                        if (deep) walk(n.children);
                    }
                });
                walk(nodes);
                return keys;
            },
            expandBtTree(expand) {
                // 每次赋新数组，保证 expand-row-keys 的 watcher 触发
                this.btExpandKeys = expand ? this.collectBtKeys(this.btTree, true) : [];
            },
            viewInList(linkId) {
                this.formInline.link_id = linkId;
                this.formInline.page = 1;
                this.activeTab = 'list'; // watch(activeTab) 负责重新查询
            },
            btRowClassName({ row }) {
                return row.node_type === 'link' ? '' : 'bt-group-row bt-row-' + row.node_type;
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            getAllLinkers(){
                getLinkerList({status:0,page: 1,limit:999999}).then(res => {
                    if(res.code ==2000) {
                        var len = res.data.filter(el=>{
                            return el.status==0;
                        })
                        localStorage.setItem('unCreatedLinkers',JSON.stringify(len));
                        localStorage.setItem('len',len.length);
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            async getWarningList(){
                await getBillWarning({page: 1,limit:999999}).then(res => {
                    if(res.code ==2000) {
                        localStorage.setItem('warningList',JSON.stringify(res.data))
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            async getAllPolicyList(payerId){
                var list1=[],list2=[];
                await listPolicy({page:1,limit:9999}).then(res=>{
                    list1=[];
                    if(res.code==2000){
                        res.data.forEach(el=>{
                            list1.push({
                                content:el.content,
                                descr:el.descr,
                                id:el.id.toString(),
                                name:el.name+'(Local)',
                                type:'Local'
                            })
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
                await listPolicyAws({payerId:payerId}).then(res=>{
                    list2=[];
                    if(res.code==2000){
                        res.data.Policies.forEach(el=>{
                            list2.push({
                                content:'',
                                descr:el.Description,
                                id:el.Id,
                                name:el.Name+'(AWS)',
                                type:'AWS'
                            })
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
                this.allPolicyData = list2.concat(list1);

                let map = new Map();
                for(let item of this.allPolicyData){
                    if(!map.has(item.name)){
                        map.set(item.name,item);
                    }
                }
                this.allPolicyData = [...map.values()]
            },
            async permissionData() {
                await this.getCustomers();
                if(this.curRole=='admin') {
                    await Promise.all([
                        this.getAgents(),
                        this.getSales(),
                        this.getPayers()
                    ]);
                } else if(this.curRole == 'sales') {
                    await Promise.all([
                        this.getAgents(),
                        this.getPayers()
                    ]);
                } else if(this.curRole == 'agent') {
                    await this.getPayers();
                }
            },
            // 获取客户列表
            async getCustomers() {
                try {
                    const res = await getCustomerList({company:'', page:1, limit:999999});
                    if(res.code === 2000) {
                        this.customersList = res.data.data || res.data;
                        this.displayedCustomers = this.customersList.slice(0, 50);
                    } else {
                        this.$message.error('获取客户列表失败：' + res.msg);
                    }
                } catch (error) {
                    console.error('获取客户列表失败:', error);
                    this.$message.error('获取客户列表失败，请稍后重试');
                }
            },
            
            // 客户下拉框搜索过滤（只显示前50条匹配结果）
            customerFilterMethod(query) {
                if (!query) {
                    this.displayedCustomers = this.customersList.slice(0, 50);
                    return;
                }
                const q = query.toLowerCase();
                this.displayedCustomers = this.customersList.filter(item => 
                    item.company && item.company.toLowerCase().includes(q)
                ).slice(0, 50);
            },

            // 获取Payer列表
            async getPayers() {
                try {
                    const res = await getPayerList({page:1, limit:999999});
                    if(res.code === 2000) {
                        this.payersList = res.data.data || res.data;
                    } else {
                        this.$message.error('获取Payer列表失败：' + res.msg);
                    }
                } catch (error) {
                    console.error('获取Payer列表失败:', error);
                    this.$message.error('获取Payer列表失败，请稍后重试');
                }
            },

            // 获取代理商列表
            async getAgents() {
                try {
                    const res = await getAgentList({page:1, limit:999999});
                    if(res.code === 2000) {
                        this.agentsList = res.data.data || res.data;
                    } else {
                        this.$message.error('获取代理商列表失败：' + res.msg);
                    }
                } catch (error) {
                    console.error('获取代理商列表失败:', error);
                    this.$message.error('获取代理商列表失败，请稍后重试');
                }
            },

            // 获取销售列表
            async getSales() {
                try {
                    const res = await getSalesList({page:1, limit:999999});
                    if(res.code === 2000) {
                        this.salesList = res.data.data || res.data;
                    } else {
                        this.$message.error('获取销售列表失败：' + res.msg);
                    }
                } catch (error) {
                    console.error('获取销售列表失败:', error);
                    this.$message.error('获取销售列表失败，请稍后重试');
                }
            },

            // 获取策略列表
            async getPolicy() {
                try {
                    const res = await listPolicy({page:1, limit:999999});
                    if(res.code === 2000) {
                        this.allPolicyData = res.data.map(el => ({
                            content: el.content,
                            descr: el.descr,
                            id: el.id.toString(),
                            name: el.name + '(Local)',
                            type: 'Local'
                        }));
                    } else {
                        this.$message.error('获取策略列表失败：' + res.msg);
                    }
                } catch (error) {
                    console.error('获取策略列表失败:', error);
                    this.$message.error('获取策略列表失败，请稍后重试');
                }
            },

            // 如果到了截止日期，显示黄色，如果超过截止日期，显示红色
            tableRowClassName({row,rowIndex}){
                if(row.name=='AutoCreated'&&row.status==0){
                    return 'yellow';
                }
            },
            
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },

            // 配置预算告警
            config(row) {
                this.formData = JSON.parse(JSON.stringify(row));
                this.isEdit = true;
                this.isConfig = true;
                this.loadingTitle = "配置预算告警";
                this.dialogVisible = true;
            },

            // 新增Link
            add() {
                this.cancel();
                this.dialogVisible = true;
                this.isEdit = false;
                this.isConfig = false;
                this.loadingTitle = "新增Link";
            },

            // 编辑Link
            edit(row) {
                this.formData = JSON.parse(JSON.stringify(row));
                this.isEdit = true;
                this.isConfig = false;
                this.loadingTitle = "编辑Link";
                this.dialogVisible = true;
            },

            // 删除Link
            remove(id) {
                this.currentDeleteId = id;
                this.deleteDialogVisible = true;
                this.deleteType = 'soft';
                this.deleteReason = '';
            },

            // 恢复Link
            restore(id) {
                this.$confirm('确定要恢复这个Link吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 调用恢复API
                    editLinker({id: id, status: 1}).then(res => {
                        if(res.code === 2000) {
                            this.$message.success('恢复成功');
                            this.getData();
                        } else {
                            this.$message.error('恢复失败：' + res.msg);
                        }
                    });
                });
            },

            // 取消对话框
            cancel() {
                this.formData = {
                    company_id:'',
                    link_id:'',
                    name:'',
                    payer_id:'',
                    agent_id:'',
                    sales:'',
                    region:'',
                    email:'',
                    budget:0,
                    budget2:0,
                    email2:'',
                    policy_id:''
                };
                this.isEdit = false;
                this.isConfig = false;
                this.dialogVisible = false;
            },

            // 提交新增
            submitData() {
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        newLinker(this.formData).then(res => {
                            if(res.code === 2000) {
                                this.$message.success(res.msg);
                                this.dialogVisible = false;
                                this.getData();
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            },

            // 提交编辑
            editSubmit(id) {
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        // 编辑保存时把"未创建(0)"转为"正常(1)"；已删除的 link 不会走到这里(编辑按钮已隐藏)
                        const data = {...this.formData, id: id, status: 1};
                        editLinker(data).then(res => {
                            if(res.code === 2000) {
                                this.$message.success(res.msg);
                                this.dialogVisible = false;
                                this.getData();
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            },

            // 取消删除
            cancelDelete() {
                this.deleteDialogVisible = false;
                this.currentDeleteId = null;
                this.deleteReason = '';
            },

            // 确认删除
            confirmDelete() {
                this.deleteLoading = true;
                const deleteData = {
                    id: this.currentDeleteId,
                    delete_type: this.deleteType,
                    reason: this.deleteReason
                };

                deleterLinker(deleteData).then(res => {
                    if(res.code === 2000) {
                        this.$message.success('删除成功');
                        this.deleteDialogVisible = false;
                        this.getData();
                    } else {
                        this.$message.error('删除失败：' + res.msg);
                    }
                                 }).finally(() => {
                     this.deleteLoading = false;
                 });
             },

             // 权限检查方法
             isShowBtn(url, module, action) {
                 return isShowBtn(url, module, action);
             },
        },
        watch: {
            activeTab() {
                this.getData();
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>

<style lang="scss" scoped>
.linker-manage {
  :deep(.el-table__fixed-right) {
    box-shadow: none;
  }
  :deep(.el-table__fixed) {
    box-shadow: none;
  }
  // Element Plus 2.x uses different class names for fixed column shadows
  :deep(.el-table--scrollable-x .el-table-fixed-column--right) {
    box-shadow: none !important;
  }
  :deep(.el-table--scrollable-x .el-table-fixed-column--left) {
    box-shadow: none !important;
  }
  .linker-tabs {
    margin: 4px 0 0;
    :deep(.el-tabs__header) {
      margin-bottom: 8px;
    }
  }
  .bt-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 4px 8px;
    .bt-summary {
      flex: 1;
      font-size: 13px;
      color: #606266;
      b {
        color: #303133;
      }
    }
  }
  .bt-level-tag {
    margin-right: 6px;
  }
  .bt-root-tag {
    margin-left: 6px;
  }
  .bt-account {
    font-family: Menlo, Consolas, monospace;
  }
  .bt-group-title {
    font-weight: 600;
  }
  :deep(.bt-row-payer) {
    background-color: #f5f7fa;
  }
}
</style>
